import React, { Component } from 'react';
import Book from './Book';

class Table extends Component {
  constructor() {
    super();
    this.handleModal = this.handleModal.bind(this);
  }

  handleModal(book) {
    this.props.handleModal(book);
  }

  render() {
    let bookComponents;
    if (this.props.books.length > 0) {
      bookComponents = this.props.books.map((book, index) => {
        return (
          <Book key={index} book={book} onClick={this.handleModal} />
        )
      });
    };
    return (
      <div className="table-container">
        <table className="table table-striped table-hover table-responsive">
          <thead>
            <tr>
              <td>Title</td>
              <td>Author</td>
              <td>Keywords</td>
            </tr>
          </thead>
          <tbody>
            {bookComponents}
          </tbody>
        </table>
      </div>
    )
  }
}

export default Table;



/** WEBPACK FOOTER **
 ** ./src/components/Books/Table.js
 **/